<script setup>
  import { computed } from "vue";
  import StatusTabs from "@/components/episto-ui/status-tabs/StatusTabs.vue";

  const props = defineProps({
    panes: { type: Array, required: true },
    counts: { type: Object, default: () => ({}) },
  });
  const pane = defineModel({ type: String, default: null });
  const tabs = computed(() =>
    props.panes.map((name) => ({
      value: name,
      label: name[0].toUpperCase() + name.slice(1),
      count: props.counts[name] || undefined,
    })),
  );
  const active = computed({ get: () => pane.value ?? props.panes[0], set: (value) => (pane.value = value) });
</script>

<template>
  <div class="flex min-h-0 flex-col overflow-hidden rounded-xl border bg-card shadow-xs">
    <StatusTabs
      v-model="active"
      class="border-b px-5 pt-3"
      :tabs="tabs" />
    <slot />
  </div>
</template>
